import LightningIcon from './icons/LightningIcon';
import ClockIcon from './icons/ClockIcon';

const ModeSelectionModal = ({ language, onSelectMode, onClose }) => {
    return (
        <div className="fixed inset-0 z-[110] flex items-center justify-center p-6 bg-black/60 backdrop-blur-sm animate-in fade-in duration-300">
            <div className="bg-white dark:bg-gray-900 rounded-3xl p-8 max-w-md w-full shadow-2xl border border-gray-200 dark:border-gray-800 animate-in zoom-in-95 duration-200">
                <div className="flex justify-between items-center mb-6">
                    <h3 className="text-2xl font-bold text-gray-900 dark:text-white">
                        {language === 'fr' ? 'Choisir le mode' : 'Exam mode selection'}
                    </h3>
                    <button onClick={onClose} className="p-2 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-full transition">
                        <svg className="w-6 h-6 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>

                <div className="space-y-4">
                    <button
                        onClick={() => onSelectMode('flash')}
                        className="w-full p-6 bg-emerald-500/10 hover:bg-emerald-500/20 border-2 border-emerald-500/20 hover:border-emerald-500 rounded-2xl transition text-left group"
                    >
                        <div className="flex items-center gap-4 mb-2">
                            <div className="w-10 h-10 bg-emerald-500 rounded-xl flex items-center justify-center text-white">
                                <LightningIcon className="w-6 h-6" />
                            </div>
                            <span className="text-xl font-bold text-gray-900 dark:text-white">
                                {language === 'fr' ? 'Mode question-réponse' : 'Flashcard Mode'}
                            </span>
                        </div>
                        <p className="text-gray-500 dark:text-gray-400 text-sm">
                            {language === 'fr'
                                ? 'Obtenez la bonne réponse et l\'explication à la validation de chaque question.'
                                : 'Receive the correct answer and explanation after validating each question.'}
                        </p>
                    </button>

                    <button
                        onClick={() => onSelectMode('classic')}
                        className="w-full p-6 bg-blue-500/10 hover:bg-blue-500/20 border-2 border-blue-500/20 hover:border-blue-500 rounded-2xl transition text-left group"
                    >
                        <div className="flex items-center gap-4 mb-2">
                            <div className="w-10 h-10 bg-blue-500 rounded-xl flex items-center justify-center text-white">
                                <ClockIcon className="w-6 h-6" />
                            </div>
                            <span className="text-xl font-bold text-gray-900 dark:text-white">
                                {language === 'fr' ? 'Mode examen' : 'Exam Mode'}
                            </span>
                        </div>
                        <p className="text-gray-500 dark:text-gray-400 text-sm">
                            {language === 'fr'
                                ? 'Validez toutes les questions avant d\'obtenir les bonnes réponses et les explications.'
                                : 'Validate all the questions before receiving the correct answers and explanations.'}
                        </p>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ModeSelectionModal;
